import { render, staticRenderFns } from "./DialogAceitarLideranca.vue?vue&type=template&id=11335288&scoped=true&"
import script from "./DialogAceitarLideranca.vue?vue&type=script&lang=js&"
export * from "./DialogAceitarLideranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11335288",
  null
  
)

export default component.exports